export default function trackEvents () {
  const elDiplomaLink = document.getElementById('diploma-link')
  
  if(elDiplomaLink)  {
    elDiplomaLink.addEventListener('click', (evt) => {
    if (typeof ga === 'function') {
      ga('send', 'event', 'PDF', 'Download', 'Intyg – PDF Download')
    }
  })
 
  }
}